import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { hrReportSearchFrom } from '@/features/hr-reports/api'
import { HeadcountScreen } from '@/features/hr-reports/headcount-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/hr/reports/headcount')({
  validateSearch: (search: Record<string, unknown>) => hrReportSearchFrom(search),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'hr_report.view')) throw redirect({ to: '/hr' })
  },
  component: HeadcountScreenRoute,
})

function HeadcountScreenRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()
  return (
    <HeadcountScreen
      search={search}
      onSearchChange={(next) => void navigate({ to: '/hr/reports/headcount', search: next })}
    />
  )
}
